/*=========================================================================================
  File Name: state.js
  Description: Order Manager State
  ----------------------------------------------------------------------------------------
  Item Name: Order Manager State Module
  Author: Tan Tran

    Pending,//0
    InProgress,//1 
    Scheduled,//2
    Ready,//3
    Unmanaged//4
    Delivered //5
==========================================================================================*/

export default {
  orders : [],
  orderManagerState : {
    capacity : 1,
    currentWaitingTime : 5,
    minWaitingTime : 5,
    maxWaitingTime : 10,
    cannotOrderNow : false,
    increaseTimeStep : 2,
    pendingOrdersIncreaseStep : 2,
    initTimeOfOrder : 2,
    offTime : null,
    isEnabled : false
  },
  resetState : false
    
}